import { render, staticRenderFns } from "./ButtonEdit.vue?vue&type=template&id=3495767f&scoped=true"
import script from "./ButtonEdit.vue?vue&type=script&lang=js"
export * from "./ButtonEdit.vue?vue&type=script&lang=js"
import style0 from "./ButtonEdit.vue?vue&type=style&index=0&id=3495767f&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3495767f",
  null
  
)

export default component.exports